import { TASK_REGISTRY_STORAGE_KEY } from '@app/providers/TaskListProvider/constants';
import type { NTaskListProvider } from '@app/providers/TaskListProvider/types';
import { safeParseJson } from '@app/shared/utils';

export const writeSession = (
  value: NTaskListProvider.PersistedTaskRegistryFilters
) => {
  sessionStorage.setItem(TASK_REGISTRY_STORAGE_KEY, JSON.stringify(value));
};

export const readSession = () =>
  safeParseJson<NTaskListProvider.PersistedTaskRegistryFilters>(
    sessionStorage.getItem(TASK_REGISTRY_STORAGE_KEY)
  );

export const clearSession = () => {
  sessionStorage.removeItem(TASK_REGISTRY_STORAGE_KEY);
};
